/**
 * v4.6.8 — 1-to-1 sidebar ↔ permission map. Every entry mirrors an admin
 * sidebar link (User Management is excluded: SysAdmin-only by design).
 * `legacy` keeps pre-v4.6.8 accounts working: when a slug is missing from the
 * stored ACL we fall back to the coarse section it used to live under.
 */
export const MENU_ITEMS = [
  { slug: "bookings",          label: "Bookings",          legacy: "reservations", actions: ["view", "create", "edit", "delete"] },
  { slug: "inquiries",         label: "Inquiries",         legacy: "reservations", actions: ["view", "create", "edit", "delete"] },
  { slug: "clients",           label: "Clients",           legacy: "reservations", actions: ["view", "create", "edit", "delete"] },
  { slug: "locations",         label: "Locations",         legacy: "settings",     actions: ["view", "create", "edit", "delete"] },
  { slug: "calendar",          label: "Calendar",          legacy: "reservations", actions: ["view"] },
  { slug: "car_groups",        label: "Car Groups",        legacy: "fleet",        actions: ["view", "create", "edit", "delete"] },
  { slug: "car_fleet",         label: "Car Fleet",         legacy: "fleet",        actions: ["view", "create", "edit", "delete"] },
  { slug: "car_extras",        label: "Car Extras",        legacy: "fleet",        actions: ["view", "create", "edit", "delete"] },
  { slug: "fleet_radar",       label: "Fleet Radar",       legacy: "fleet",        actions: ["view"] },
  { slug: "vouchers",          label: "Vouchers",          legacy: "pricing",      actions: ["view", "create", "edit", "delete"] },
  { slug: "price_radar",       label: "Price Radar",       legacy: "price_radar",  actions: ["view", "edit"] },
  { slug: "reports",           label: "Reports",           legacy: "settings",     actions: ["view"] },
  { slug: "rental_settings",   label: "Rental Settings",   legacy: "settings",     actions: ["view", "edit"] },
  { slug: "business_settings", label: "Business Settings", legacy: "settings",     actions: ["view", "edit"] },
  { slug: "system_settings",   label: "System Settings",   legacy: "settings",     actions: ["view", "edit"] },
];

export const MENU_SLUGS = MENU_ITEMS.map((m) => m.slug);
export const ACL_ACTIONS = ["view", "create", "edit", "delete"];

const LEGACY_OF = Object.fromEntries(MENU_ITEMS.map((m) => [m.slug, m.legacy]));

export function hasMenuPerm(user, slug, action = "view") {
  if (!user) return false;
  if (user.role === "super_admin") return true;
  const acl = user.acl || {};
  if (acl[slug]) return !!acl[slug][action];
  const legacy = LEGACY_OF[slug];
  return !!(legacy && acl[legacy] && acl[legacy][action]);
}

export function emptyMenuAcl() {
  return Object.fromEntries(
    MENU_ITEMS.map((m) => [m.slug, { view: false, create: false, edit: false, delete: false }]),
  );
}
